/**
 * The group panel type: a container showing several panels together in one card.
 */

/* No fields: the block holds a list of child panels, which is checked against the rest of the page
   rather than field by field. */
const group = {
  names: [{ id: 'group', label: 'Group', guide: 'group.md', container: true, advanced: false, toolSummary: 'a container showing several panels together in one card, divided by hairlines instead of gaps — for panels that read as a single report', promptSummary: 'a container showing several panels together in one card divided by hairlines, for panels that read as a single report' }],
  block: 'group',
  toolSchema: {
    type: ['object', 'null'],
    additionalProperties: false,
    required: ['items'],
    description: 'Group container config (displayType "group"): full replacement of the child list. The children render TOGETHER inside one card on the group\'s own 12-column grid, divided by hairlines — use it when several panels read as one report (a row of stat tiles above their chart), not to save space. Each child leaves the page grid while grouped. A child may itself be a container. Pass null to clear the group and release every child back to the grid. Read immutable/analytics/panel-types/group.md before the first group config.',
    properties: {
      items: {
        type: 'array',
        description: "The children and where each sits on the group's own 12-column grid.",
        items: {
          type: 'object',
          additionalProperties: false,
          required: ['panelId'],
          properties: {
            panelId: { type: 'string', description: 'Child panel id from analytics_page_get or analytics_panel_create.' },
            /* 2026-10-08: "omit and the child takes a full-width row" contradicted group.md's flow, and
               an omitted pair was stored as 0,0 until then (validateAnalyticsContainerItems). */
            x: { type: ['number', 'null'], description: 'Leftmost column INSIDE the group, 0-11. Leave x and y out and the child flows left to right in list order, wrapping when the row fills; that is the usual way.' },
            y: { type: ['number', 'null'], description: 'Top row inside the group, 0-based. Pass it with x, or neither.' },
            w: { type: ['number', 'null'], description: 'Width in columns, 1-12.' },
            h: { type: ['number', 'null'], description: 'Height in rows (one row ≈ 48px). Stat tiles want 3.' }
          }
        }
      },
      showChildHeaders: { type: ['boolean', 'null'], description: "Whether each child keeps its own title row inside the group. Defaults to true — a stat tile's title IS the label of its number. Pass false only for children whose meaning is obvious without labels." }
    }
  }
};

export default group;
